"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LangfuseConflictError = void 0;
const BaseError_1 = require("./BaseError");
class LangfuseConflictError extends BaseError_1.BaseError {
    constructor(description = "Conflict") {
        super("LangfuseConflictError", 409, description, true);
    }
}
exports.LangfuseConflictError = LangfuseConflictError;
